import Profile from '@js/app/pages/Profile.vue';
import Timetable from '@js/app/pages/Timetable.vue';
import EducationalMaterials from '@js/app/pages/EducationalMaterials.vue';
import Classmates from '@js/app/pages/Classmates.vue';
import Students from '@js/app/pages/Students.vue';
import Teachers from '@js/app/pages/Teachers.vue';
import Payment from '@js/app/pages/Payment.vue';
import PaymentSuccessFailed from '@js/app/pages/PaymentSuccessFailed.vue';
import Attendance from '@js/app/pages/Attendance.vue';
import Library from '@js/app/pages/Library.vue';
import Menu from '@js/app/pages/Menu.vue';
import Pay from '@js/app/pages/Pay.vue';
import Page404 from '@js/app/pages/Page404.vue';
import Support from '@js/app/pages/Support.vue';
import RecordBook from '@js/app/pages/RecordBook.vue';
import Telegram from '@js/app/pages/Telegram.vue';
import TelegramDetail from '@js/app/pages/TelegramDetail.vue';
import Notifications from '@js/app/pages/Notifications.vue';
import Applicant from '@js/app/pages/Applicant.vue';
import Schedule from '@js/app/pages/Schedule.vue';
import Works from '@js/app/pages/Works.vue';
import Chat from '@js/app/pages/Chat.vue';

const routes = [
    {
        path: '/',
        component: Timetable,
        id: 'Timetable',
        icon: 'calendar',
        iconFooter: 'mcalendar',
        meta: {
            title: 'Расписание',
            menuFooter: true,
            className: 'tablet-hide',
            rolesBan: ['expelled_student', 'academic_vacation_student'],
        },
    },
    {
        path: '/profile/',
        component: Profile,
        id: 'profile',
        icon: '',
        iconFooter: '',
        meta: {
            title: 'Мой профиль',
            menuHide: true,
        },
    },
    {
        path: '/materials/',
        component: EducationalMaterials,
        id: 'EducationalMaterials',
        icon: 'educational',
        iconFooter: '',
        meta: {
            title: 'Учебные материалы',
            rolesBan: ['expelled_student', 'academic_vacation_student'],
        },
    },
    {
        path: '/classmates/',
        component: Classmates,
        id: 'classmates',
        icon: 'classmates',
        iconFooter: '',
        meta: {
            title: 'Одногруппники',
            roles: 'student',
            rolesBan: ['expelled_student', 'academic_vacation_student'],
        },
    },
    {
        path: '/students/',
        component: Students,
        id: 'classmates',
        icon: 'classmates',
        iconFooter: '',
        meta: {
            title: 'Студенты',
            roles: 'teacher',
        },
    },
    {
        path: '/teachers/',
        component: Teachers,
        id: 'teachers',
        icon: 'teachers',
        iconFooter: '',
        meta: {
            title: 'Преподаватели',
            rolesBan: ['expelled_student', 'academic_vacation_student'],
        },
    },
    {
        path: '/works/',
        component: Works,
        id: 'Works',
        icon: 'document',
        iconFooter: '',
        meta: {
            title: 'Мои работы',
            titleStudent: 'Мои работы',
            titleTeacher: 'Работы студентов',
            rolesBan: ['expelled_student', 'academic_vacation_student'],
        },
    },
    {
        path: '/payment/',
        component: Payment,
        id: 'Payment',
        icon: 'payment',
        iconFooter: '',
        meta: {
            title: 'Оплата обучения',
            roles: 'student',
        },
    },
    {
        path: '/record-book/',
        component: RecordBook,
        id: 'RecordBook',
        icon: 'library',
        iconFooter: '',
        meta: {
            title: 'Зачетная книжка',
            roles: 'student',
            rolesBan: ['expelled_student', 'academic_vacation_student'],
        },
    },
    {
        path: '/record-book-student/',
        component: RecordBook,
        name: 'Зачетная книжка студента',
        id: 'RecordBookStudent',
        icon: 'library',
        iconFooter: '',
        meta: {
            title: 'Зачетная книжка студента',
            roles: 'teacher',
            menuHide: true,
        },
    },
    {
        path: '/payment/status/',
        component: PaymentSuccessFailed,
        id: 'PaymentMessage',
        meta: {
            title: 'Статус оплаты',
            layout: 'blank',
            menuHide: true,
            pageOpen: true,
        },
    },
    {
        path: '/attendance/',
        component: Attendance,
        id: 'Attendance',
        icon: 'attendance',
        iconFooter: '',
        meta: {
            title: 'Посещаемость',
            roles: 'student',
            rolesBan: ['expelled_student', 'academic_vacation_student'],
        },
    },
    {
        path: '/attendance-student/',
        component: Attendance,
        id: 'AttendanceStudent',
        icon: 'attendance',
        iconFooter: '',
        meta: {
            title: 'Посещаемость',
            roles: 'teacher',
            menuHide: true,
        },
    },
    {
        path: '/library/',
        component: Library,
        id: 'library',
        icon: 'book',
        iconFooter: '',
        meta: {
            title: 'Электронная библиотека',
            rolesBan: ['expelled_student', 'academic_vacation_student'],
        },
    },
    {
        path: '/telegram/',
        component: Telegram,
        id: 'Telegram',
        icon: 'telegram',
        iconFooter: '',
        meta: {
            title: 'Telegram-рассылки',
            roles: 'leader',
            rolesBan: ['expelled_student', 'academic_vacation_student'],
        },
    },
    {
        path: '/telegram/:id',
        component: TelegramDetail,
        meta: {
            title: 'Telegram-рассылка',
            roles: 'leader',
            menuHide: true,
            rolesBan: ['expelled_student', 'academic_vacation_student'],
        },
    },
    {
        path: '/notifications/',
        component: Notifications,
        iconFooter: 'push',
        id: 'Notifications',
        meta: {
            title: 'Уведомления',
            menuFooter: true,
            menuHide: true,
            rolesBan: ['expelled_student', 'academic_vacation_student'],
        },
    },
    {
        path: '/support/',
        component: Support,
        id: 'Support',
        icon: 'qa',
        iconFooter: '',
        meta: {
            title: 'Поддержка',
            rolesBan: ['expelled_student', 'academic_vacation_student'],
        },
    },
    {
        path: '/menu/',
        component: Menu,
        id: 'Menu',
        icon: '',
        iconFooter: 'menu',
        meta: {
            title: 'Меню',
            menuFooter: true,
            menuHide: true,
        },
    },
    {
        path: '/app-form/',
        component: Applicant,
        id: 'ApplicantForm',
        meta: {
            title: 'Заявление абитуриента',
            menuHide: true,
            pageOpen: true,
        },
    },
    {
        path: '/schedule/',
        component: Schedule,
        id: 'Schedule',
        meta: {
            title: 'Расписание',
            menuHide: true,
            pageOpen: true,
        },
    },
    {
        path: '/chat/',
        component: Chat,
        id: 'Chat',
        meta: {
            title: 'Сообщения',
            menuHide: true,
        },
    },
    {
        path: '/pay/',
        component: Pay,
        id: 'Pay',
        meta: {
            title: 'Онлайн оплата',
            menuHide: true,
            layout: 'blank',
            pageOpen: true,
            oldAuhHide: true,
        },
    },
    {
        path: '/:pathMatch(.*)*',
        component: Page404,
        meta: {
            title: 'Страница не найдена',
            menuHide: true,
            layout: 'blank',
        },
    },
];

export default routes;
